<template>
  <div>
    <div class="clearfix" id="login-header">
      <div class="logo" style="background-color: #fff">
        <img
          style="width: 56px; vertical-align: -1em"
          src="../assets/images/logo_256.png"
        />
        <span style="font-size: 30px; line-height: 77px"
          >宁波国企阳光采购电子交易云平台</span
        >
      </div>
    </div>
    <div class="loginbg">
      <div class="loginbox1">
        <div class="zhucebox">
          <!-- <div class="zhucetle">@ViewBag.Title</div> -->
          <div class="phonebox">技术支持电话：0574-86820848</div>
        </div>
        <router-view />
      </div>
    </div>

    <div class="footer">
      <div class="container">
        <!-- @*<a href="http://z-c-y.com/" target="_blank">官网</a
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <a
          href="http://z-c-y.com/Information/HelpCenter?ClassID=07&MenuID=070101"
          target="_blank"
          >帮助</a
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <a href="http://z-c-y.com/About/clause" target="_blank">条款</a
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <a href="http://z-c-y.com/About/about" target="_blank">关于</a>
        <br />*@ -->
        <p>
          Copyright ©
          宁波国企阳光采购电子交易云平台&nbsp;&nbsp;&nbsp;&nbsp;宁波杰瑞软件有限公司
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
